import { render, staticRenderFns } from "./Online-Consultant.vue?vue&type=template&id=3c4a2c29&scoped=true&"
import script from "./Online-Consultant.vue?vue&type=script&lang=js&"
export * from "./Online-Consultant.vue?vue&type=script&lang=js&"
import style0 from "./Online-Consultant.vue?vue&type=style&index=0&id=3c4a2c29&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a2c29",
  null
  
)

export default component.exports